import { lazy } from 'react';
import withSuspense from 'utils/withSuspense';
const ContactFormIndex = lazy(() => import('features/contact-form/components/ProductsIndex'));

const ContactFormRoute = withSuspense(ContactFormIndex);

export default ContactFormRoute;
